import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { usePageTitle } from './hooks/usePageTitle';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Tuney from './pages/Tuney';
import Bace from './pages/Bace';
import CBYON from './pages/CBYON';
import BreweryDB from './pages/BreweryDB';
import BrewLogix from './pages/BrewLogix';
import TMobile5Gin from './pages/TMobile5Gin';
import Music from './pages/Music';
import MusicLinks from './pages/MusicLinks';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isStandaloneMusicPage =
    location.pathname === '/music' || location.pathname === '/music/links';
  usePageTitle();

  if (isStandaloneMusicPage) {
    return (
      <>
        <ScrollToTop />
        <Routes>
          <Route path="/music" element={<Music />} />
          <Route path="/music/links" element={<MusicLinks />} />
        </Routes>
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <div className="App">
        <div className="pointer-events-none fixed z-0 h-80 w-96 -left-56 -top-80 rotate-45 bg-[#2B5EE9] opacity-70 blur-[624px]" aria-hidden="true" />
        <div className="pointer-events-none fixed z-0 h-80 w-96 -bottom-80 -right-64 rotate-45 bg-[#51167E] opacity-70 blur-[624px]" aria-hidden="true" />
        <div className="sidebar-wrapper flex min-h-svh w-full bg-zinc-200 dark:bg-zinc-900">
          <Sidebar />
          <main className="relative z-10 flex w-full flex-1 flex-col bg-white text-zinc-800 dark:bg-black dark:text-zinc-200 md:m-2 md:ml-0 md:rounded-xl md:shadow-sm">
            <Header />
            <div className="flex flex-1 flex-col">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/work" element={<Navigate to="/" replace />} />
                <Route path="/about" element={<About />} />
                <Route path="/tuney" element={<Tuney />} />
                <Route path="/bace" element={<Bace />} />
                <Route path="/cbyon" element={<CBYON />} />
                <Route path="/brewerydb" element={<BreweryDB />} />
                <Route path="/brewlogix" element={<BrewLogix />} />
                <Route path="/t-mobile-5gin" element={<TMobile5Gin />} />
              </Routes>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
